<template>
  <section></section>
</template>

<script>
export default {
  name: 'MerchantHero'
}
</script>
